import React from 'react';

export default function ComingSoon() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '60vh', textAlign: 'center' }}>
      <div style={{ fontSize: 72, marginBottom: 24 }}>🃏</div>
      <h1 style={{ fontSize: 32, marginBottom: 12, fontFamily: 'Sora' }}>Revision Cards</h1>
      <p style={{ fontSize: 18, color: 'var(--text-muted)', marginBottom: 8 }}>Coming Soon</p>
      <p style={{ fontSize: 14, color: 'var(--text-muted)', maxWidth: 400 }}>
        We are working on an intelligent flashcard system to supercharge your revision. Stay tuned!
      </p>
    </div>
  );
}
